export default {
	CONTENT_FEEDBACK: 'content-feedback',
	FEATURE_REQUESTS: 'feature-requests',
	SLIDE_EDITOR: 'slide-editor',
	PRODUCT_FEEDBACK: 'product-feedback',
}
